import { rule, required, isValidEmail, maxLength, match } from 'components/Shared/Form/rules';
import { rm } from 'utils';
import { AddressInfo } from 'models/AddressInfo';

const isValidApartmentNum = match(/^[0-9]{4}$/);
const isValidOrganizationNum = match(/^[0-9]{6}-?[0-9]{4}$/);

export type ValidationRule = (errorMessage: string) => undefined | string;
export type Validator = (v: string) => string | undefined;

export const optional = (validator: Validator) => (v: string) => {
  if (v === undefined) {
    return undefined;
  }
  return validator(v);
};

export const name = rule(() => rm('checkout_error_name_private'), required);

export const nameLength = (max?: number) => (_: string, allValues: never) => {
  if (!max) {
    return;
  }

  const { address } = allValues;
  const { firstName, lastName } = address as AddressInfo;

  const trimmedFirstNameLength = firstName?.trim().length ?? 0;
  const trimmedLastNameLength = lastName?.trim().length ?? 0;

  if (trimmedFirstNameLength + trimmedLastNameLength > max) {
    return rm('checkout_too_long_name_error', max);
  }

  return;
};

export const deliveryNameLength = (max?: number) => (_: string, allValues: never) => {
  if (!max) {
    return;
  }

  const { address } = allValues;
  const { deliveryAddress } = address as AddressInfo;

  const trimmedFirstNameLength = deliveryAddress?.firstName?.trim().length ?? 0;
  const trimmedLastNameLength = deliveryAddress?.lastName?.trim().length ?? 0;

  if (trimmedFirstNameLength + trimmedLastNameLength > max) {
    return rm('checkout_too_long_name_error', max);
  }

  return;
};

export const email = rule(() => rm('checkout_error_email'), isValidEmail);
export const address = rule(() => rm('checkout_error_address'), required);
export const city = rule(() => rm('checkout_error_zip_city'), required);
export const cadastral = rule(() => rm('checkout_rotreduction_error_property'), required);
export const apartmentNumber = rule(
  () => rm('checkout_rotreduction_error_apartmentnum'),
  isValidApartmentNum
);
export const apartmentOrganisationNumber = rule(
  () => rm('checkout_rotreduction_error_organisationnum'),
  isValidOrganizationNum
);

export const CHECKOUT_CONTACT_MESSAGE_LENGTH = 500;
const messageLength = maxLength(CHECKOUT_CONTACT_MESSAGE_LENGTH + 1);
export const normalizeMessage = (v: string, p: string) => (!messageLength(v) ? v : p);
